import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";

export default function Dashboard() {
  return (
    <div className="flex w-full">
      <Sidebar />

      <div className="flex-1">
        <Navbar />

        <div className="p-6">
          <h2 className="text-xl font-bold mb-4">Innovation Meets Sustainability in the Heart of Dubai..</h2>
          <p className="text-gray-700">At NOA Lab, we empower startups, enterprises, and governments to design future-ready solutions across energy, mobility, AI, and green technologies.</p>
          <p>&nbsp;</p>
          <h2>Accelerating Sustainable Innovation for a Better Tomorrow</h2>
          <p>NOA Lab is a next-generation innovation hub in Dubai, dedicated to accelerating sustainable solutions that address global challenges. Our ecosystem brings together entrepreneurs, investors, corporations, and policy leaders to co-create impact.</p>
        </div> 

        <div className="p-6">
          <iframe width="560" height="315" src="https://www.youtube.com/embed/JENTZriqihA?si=UY6tSJa-HSs1andW" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen=""></iframe>
        </div>         

        {/* <div className="p-6 grid grid-cols-3 gap-6">
          <Card title="Total Leads" value="12" />
          <Card title="My Leads" value="5" />
          <Card title="Applications" value="8" />
        </div> */}
        
      </div>
    </div>
  );
}

function Card({ title, value }) {
  return (
    <div className="bg-white p-6 rounded-xl shadow">
      <p className="text-gray-500">{title}</p>
      <h2 className="text-2xl font-bold">{value}</h2>
    </div>
  );
}